// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-system-notifications-tasks .fi-wrapper-table .mat-mdc-cell {
  cursor: pointer;
}
.fi-system-notifications-tasks .fi-wrapper-table .mat-column-Name {
  min-width: 55%;
}`, "",{"version":3,"sources":["webpack://./Source/app/system-notifications/tasks/tasks.component.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;AADZ;AAGQ;EACI,cAAA;AADZ","sourcesContent":[".fi-system-notifications-tasks {\r\n    .fi-wrapper-table {\r\n        .mat-mdc-cell {\r\n            cursor: pointer;\r\n        }\r\n        .mat-column-Name {\r\n            min-width: 55%;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
